import { useEffect, useState } from "react";

const placeholderUrl = "/bg.svg";

const useBackgroundWithSVGPlaceholder = (imageUrl) => {
	const [backgroundImage, setBackgroundImage] = useState(
		`url("${placeholderUrl}")`
	);

	useEffect(() => {
		let cancelled = false;

		// reset to placeholder whenever the URL changes
		setBackgroundImage(`url("${placeholderUrl}")`);
		if (!imageUrl) return;

		const img = new Image();
		img.src = imageUrl;

		const swap = () => {
			if (!cancelled) setBackgroundImage(`url("${imageUrl}")`);
		};

		if (img.decode) {
			img
				.decode()
				.then(swap)
				.catch(() => {
					// fallback if decode rejects (e.g., CORS or older formats)
					img.onload = swap;
				});
		} else {
			img.onload = swap;
		}

		img.onerror = () => {
			// keep the placeholder on error; you could log/emit here if needed
		};

		return () => {
			cancelled = true;
		};
	}, [imageUrl, placeholderUrl]);

	return backgroundImage;
};

export default useBackgroundWithSVGPlaceholder;
